import React from "react";
import { useEffect, useState, useCallback } from "react";
import './eassistant.css';
import './App.css';
import AuthPage from "./components/AuthPage";
import Sidebar from "./components/Sidebar";
import MainPage from "./components/MainPage";
import RequestsPage from "./components/RequestsPage";
import GesturesPage from "./components/GesturesPage";
import SentencesPage from "./components/SentencesPage";
import TranslationPage from "./components/TranslationPage";
import { useAppStore } from "./store/useAppStore";

function App() {
  const isAuthenticated = useAppStore((state) => state.isAuthenticated);
  const token = useAppStore((state) => state.token);
  const authChecking = useAppStore((state) => state.authChecking);
  const validateToken = useAppStore((state) => state.validateToken);
  const activePage = useAppStore((state) => state.activePage);
  const visualPreset = useAppStore((state) => state.visualPreset);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = useCallback(() => setMobileMenuOpen(false), []);

  useEffect(() => {
    if (token) {
      validateToken();
    }
  }, [token, validateToken]);

  useEffect(() => {
    document.body.classList.remove("glass-default", "glass-cold");
    document.body.classList.add(visualPreset || "glass-default");
  }, [visualPreset]);

  useEffect(() => {
    closeMobileMenu();
  }, [activePage, closeMobileMenu]);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [mobileMenuOpen]);

  if (authChecking) {
    return <div className="sign-loading">Загрузка...</div>;
  }

  if (!isAuthenticated) {
    return (
      <div className="app-root">
        <AuthPage />
      </div>
    );
  }

  return (
    <div className="app-root">
      <div
        className={`mobile-sidebar-overlay ${mobileMenuOpen ? "active" : ""}`}
        onClick={closeMobileMenu}
      />
      <Sidebar mobileOpen={mobileMenuOpen} onMobileClose={closeMobileMenu} />
      <button
        className="mobile-menu-btn"
        type="button"
        onClick={() => setMobileMenuOpen((prev) => !prev)}
        aria-label="Меню"
      >
        <i className={`fa-solid ${mobileMenuOpen ? "fa-xmark" : "fa-bars"}`} aria-hidden="true"></i>
      </button>
      {activePage === "requests" ? <RequestsPage /> : null}
      {activePage === "gestures" ? <GesturesPage /> : null}
      {activePage === "sentences" ? <SentencesPage /> : null}
      {activePage === "translation" ? <TranslationPage /> : null}
      {activePage !== "requests" && activePage !== "gestures" && activePage !== "sentences" && activePage !== "translation"
        ? <MainPage /> : null}
    </div>
  );
}

export default App;
